// See https://gitlab.com/gitlab-org/gitlab-ui/-/issues/1421#note_617098438
// for more details
export const forbiddenDataAttrs = [
  'data-remote',
  'data-url',
  'data-type',
  'data-method',
  'data-disable-with',
  'data-disabled',
  'data-disable',
  'data-turbo',
];

export const forbiddenTags = ['style', 'mstyle', 'form'];
